import features from '~/config/features.cjs'

export const state = () => ({
  service: null
})

export const mutations = {
  async SET_SERVICE (state, service) {
    state.service = service
  }
}

export const actions = {
  fetchPlayBillingService ({ commit }) {
    // Keep the integration for later, but do not probe Google Play while payments are disabled.
    if (!features.payments) return

    console.debug('[servicePlayBilling.js] commit(\'SET_SERVICE\', service)')

    window.getDigitalGoodsService('https://play.google.com/billing')
      .then(service => {
        console.debug('[servicePlayBilling.js] commit(\'SET_SERVICE\', service)', service)
        commit('SET_SERVICE', service)
      })
      .catch(e => {
        this.$sentry.captureException(e)
      })
  },
  async asyncFetchPlayBillingService ({ commit }) {
    // Keep the integration for later, but do not probe Google Play while payments are disabled.
    if (!features.payments) return

    console.debug('[servicePlayBilling.js] commit(\'SET_SERVICE\', service)')

    window.getDigitalGoodsService('https://play.google.com/billing')
      .then(service => {
        console.debug('[servicePlayBilling.js] commit(\'SET_SERVICE\', service)', service)
        commit('SET_SERVICE', service)
      })
      .catch(e => {
        this.$sentry.captureException(e)
      })
  },
}
